import React from 'react';
import { Link } from 'react-router-dom';

const HomeBlogSection = ({ articlesStatus, latestPosts }) => {
  return (
    <section id="blog" aria-labelledby="blog-title" className="site-bg-section py-20 px-6">
      <div className="container mx-auto">
        <div className="max-w-2xl mx-auto text-center">
          <h2
            id="blog-title"
            className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl"
          >
            From the Blog
          </h2>
          <p className="mt-4 text-lg text-gray-600">Alguns temas que estou estruturando agora.</p>
        </div>
        <div className="mt-16 space-y-8 max-w-3xl mx-auto">
          {articlesStatus === 'loading' && (
            <div className="text-center text-gray-600">Carregando artigos...</div>
          )}
          {articlesStatus === 'error' && (
            <div className="text-center text-red-600">
              Nao foi possivel carregar os artigos agora.
            </div>
          )}
          {articlesStatus === 'success' && latestPosts.length === 0 && (
            <div className="text-center text-gray-600">Nenhum artigo publicado ainda.</div>
          )}
          {articlesStatus === 'success' &&
            latestPosts.map((post) => (
              <div
                key={post.id}
                className="bg-white p-6 rounded-lg border border-gray-200 shadow-lg site-card hover:shadow-xl transition-shadow duration-300"
              >
                <p className="text-sm text-gray-500 mb-1">{post.category}</p>
                <h3 className="text-2xl font-semibold mb-2">
                  <Link to={`/blog/artigos/${post.slug}`} className="hover:text-blue-600">
                    {post.title}
                  </Link>
                </h3>
                <p className="text-gray-600 mb-4">{post.excerpt}</p>
                <Link
                  to={`/blog/artigos/${post.slug}`}
                  className="font-semibold text-blue-600 hover:underline"
                >
                  Read More &rarr;
                </Link>
              </div>
            ))}
        </div>
        <div className="text-center mt-12">
          <Link to="/blog" className="text-lg font-semibold text-blue-600 hover:underline">
            Visit Blog
          </Link>
        </div>
      </div>
    </section>
  );
};

export default HomeBlogSection;
